import { Component } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '.../../environments/environment';
import { AuthService } from '../../../_services/index';
import { LoaderService } from 'app/_services/loader.service';
import { process, State } from '@progress/kendo-data-query';
import { GroupDescriptor, DataResult } from '@progress/kendo-data-query';
import { GridDataResult, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { Observable } from 'rxjs/Observable';
import { ExcelExportData } from '@progress/kendo-angular-excel-export';
import { utils, write, WorkBook } from 'xlsx';
import { saveAs } from 'file-saver';
import { Router } from '@angular/router';
// import Swal from 'sweetalert2';
import 'firebase/firestore';

import * as _moment from 'moment';
import * as _rollupMoment from 'moment';

const moment = _rollupMoment || _moment;
export const MY_FORMATS = {
	parse: {
		dateInput: 'LL'
	},
	display: {
		dateInput: 'LL',
		monthYearLabel: 'MMM YYYY',
		dateA11yLabel: 'LL',
		monthYearA11yLabel: 'MMMM YYYY'
	}
};

import { AngularFirestore, AngularFirestoreDocument } from 'angularfire2/firestore';

import { VehMaintenanceService } from './vehMaintenance.service';
import { MaintVehicle } from './vehMaintenance.model';
import { escapeSelector } from 'jquery';
import { truncate } from 'lodash';

declare var $: any;
const distinctStatus = (data) =>data.filter((x, idx, xs) => xs.findIndex((y) => y.maintenanceStatus === x.maintenanceStatus) === idx);
const distinctCat = (data) => data.filter((x, idx, xs) => xs.findIndex((y) => y.vehcatname === x.vehcatname) === idx);
const distinctType = (data) => data.filter((x, idx, xs) => xs.findIndex((y) => y.vehTypName === x.vehTypName) === idx);
const distinctIMEI = (data) => data.filter((x, idx, xs) => xs.findIndex((y) => y.VTSSTATUS === x.VTSSTATUS) === idx);
const distinctStage = (data) => data.filter((x, idx, xs) => xs.findIndex((y) => y.STAGENAME === x.STAGENAME) === idx);


const checklistStatus =   (data) => data.filter((x, idx, xs) => xs.findIndex((y) => y.Status === x.Status) === idx);

const lastPingDate =    (data) => data.filter((x, idx, xs) => xs.findIndex((y) => y.lastPing === x.lastPing) === idx);

const approvedService =    (data) => data.filter((x, idx, xs) => xs.findIndex((y) => y.approved_service === x.approved_service) === idx);

@Component({
	selector: 'maintenance-veh',
	templateUrl: './VehicleMaintenanceApproval.html',
  styles: ['.green .codeColumn { color: green; font-weight: bold} .red .codeColumn { color: red; font-weight: bold}'],
	
})
export class VehMaintenanceApprovalComponent {
	public prjId: any;
  public userId: any;
  public showLoader: boolean;
  public total: number = 80;
	public state: State = {
		skip: 0,
		take: 50,
		filter: {
			logic: 'and',
			filters: []
		}
	};
  public date = moment();
  firebaseData: any;
  stopsValue: any;
  isVtsData: boolean;
  approvalsuccessMsgcheck: boolean;
  refid: any;
  isChecked1: boolean;
  isChecked2: boolean;
  isChecked3: boolean;
  isChecked1error: boolean;
  VehicleApprovalChecklist: any;
  IMEI: any;
  defStartDt: string;
  defEndDt: string;
  dataRangeModal: { beginDate: { year: number; month: number; day: number; }; endDate: { year: number; month: number; day: number; }; };
  startDate: string;
  endDate: string;
  vehicleNumber: any;
  public checklistStatus: any[];
  public lastPingDate: any[];
  public approvedService: any[];
  isChecked4: boolean;
  
  public allData(): ExcelExportData {
		const result: ExcelExportData = {
			data: this.VehicleApprovalChecklist 
		};
		return result;
	}

	public groups: GroupDescriptor[] = [];
	public view: Observable<GridDataResult>;
	public gridView: DataResult;
	public items: Observable<any[]>;

	options = {
		componentRestrictions: {
			country: ['IN']
		}
	}

	maintItems: Observable<MaintVehicle[]>;
	vehMaintDoc: AngularFirestoreDocument<MaintVehicle>;

	public groupChange(groups: GroupDescriptor[]): void {
		this.groups = groups;
		this.loadProducts();
	}

	private loadProducts(): void {
		this.gridDataVehList = process(this.VehicleApprovalChecklist, { group: this.groups });
	}
	public gridDataVehList: GridDataResult;



	constructor(
		private auth: AuthService,
		private http: HttpClient,
		private loaderService: LoaderService,
		public router: Router,
		public db: AngularFirestore,
		private vehMaintenanceService: VehMaintenanceService, //service file, just in case
		public afs: AngularFirestore,
	) {
		this.loaderService.status.subscribe((val: boolean) => {
			this.showLoader = val;
		});
    var date = new Date();
    var date = new Date();
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    this.defStartDt = (firstDay.getFullYear()) + '-' + (firstDay.getMonth() + 1) + '-' + firstDay.getDate();
    this.defEndDt = (date.getFullYear()) + '-' + (date.getMonth() + 1) + '-' + date.getDate();
    this.dataRangeModal = { beginDate: { year: firstDay.getFullYear(), month: firstDay.getMonth() + 1, day: firstDay.getDate() }, endDate: { year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate() } };
		this.allData = this.allData.bind(this);
	}

  ngOnInit() {
    this.startDate = moment(this.defStartDt).format('YYYY-MM-DD');
    this.endDate = moment(this.defEndDt).format('YYYY-MM-DD');
    this.prjId = this.auth.getAuthentication().projectId;
    this.userId = this.auth.getAuthentication().id;

    console.log(this.userId);
    

    this.getMaintenanceVehicleApprovalChecklist();
  
}
public dataStateChange(state: DataStateChangeEvent): void {
  this.state = state;
  this.gridDataVehList = process(this.VehicleApprovalChecklist, this.state);
 

  if (state && state.group) {
    this.gridDataVehList = process(this.VehicleApprovalChecklist, this.state);


    
    // this.distinctStatus = distinctStatus(this.vehMaintenanceList);
    // this.distinctCat = distinctCat(this.vehMaintenanceList);
    // this.distinctType = distinctType(this.vehMaintenanceList);
    // this.distinctIMEI = distinctIMEI(this.vehMaintenanceList);
    // this.distinctStage = distinctStage(this.vehMaintenanceList);
  }
}
	// one
  getcheckVtsStopsdata(){


    this.http.get(environment.apiUrl + 'maintenance/getcheckVtsStopsdata?prjid='+this.prjId+"&IMEI="+this.IMEI).subscribe((data) => {

      console.log(this.stopsValue);
      
    
       this.stopsValue = data
  
      if(this.stopsValue.TotalCount == 0){
     
            this.isVtsData = true ;
         
      }
      
       
     
    });
  
  }




  // two
  approveCheklist(){

   
    if(this.isChecked1 == null || this.isChecked1 == undefined  ){
         this.isChecked1error = true
          return false;
      }
    if(this.isChecked2 == null || this.isChecked2 == undefined ){
      this.isChecked1error = true
      return false;
    }


 var checklistdata = {

  'refid' :   this.refid,
  'batteryStatus'     :  this.isChecked1 == true?1:0,
  'vtsStatus'     :  this.isChecked2 == true?1:0,
  'jingle':this.isChecked3 == true?1:0,
  'tempApproval':this.isChecked4 == true ?1:0


 }



  
 this.http.post(environment.apiUrl + 'maintenance/maintenanceChecklistApproval',checklistdata).subscribe((data) => {
    

   this.approvalsuccessMsgcheck = true

    setTimeout(() => {
     this.getMaintenanceVehicleApprovalChecklist();
     $('#changeStatusModal').modal('hide');
     this.approvalsuccessMsgcheck = false
   }, 1000);


 });

  }





getMaintenanceVehicleApprovalChecklist(){

  this.loaderService.display(true);

  this.http.get(environment.apiUrl + 'maintenance/getMaintenanceVehicleApprovalChecklist?prjid='+this.prjId).subscribe((data) => {
     this.VehicleApprovalChecklist = data;

     console.log('256',data);
     

     this.gridDataVehList = process(this.VehicleApprovalChecklist, this.state);
     
     this.checklistStatus  = checklistStatus(this.VehicleApprovalChecklist) ;

     this.lastPingDate = lastPingDate(this.VehicleApprovalChecklist)

     this.approvedService  = approvedService(this.VehicleApprovalChecklist) ;

     console.log('90',this.VehicleApprovalChecklist);
     
      this.loaderService.display(false);
   });
 }


 async saveApprovel(refid,IMEI,vehno){

  this.refid = refid,
  this.IMEI = IMEI,
  this.vehicleNumber = vehno ;
   this.isChecked1error = false ,
    $('#changeStatusModal').modal('show');


    this.getcheckVtsStopsdata();

}


tempApprovel(refid,IMEI,vehno){

  var updatelistdata = {

    'refid' :   refid,
    'vehno' : vehno
  }

  

   console.log('updatelistdata',updatelistdata);
   



  this.http.post(environment.apiUrl + 'maintenance/maintenanceChecklistTempApproval',updatelistdata).subscribe((data) => {
    


    console.log('311',data);
    

    // this.approvalsuccessMsgcheck = true
 
    //  setTimeout(() => {
    //   this.getMaintenanceVehicleApprovalChecklist();
    //   $('#changeStatusModal').modal('hide');
    //   this.approvalsuccessMsgcheck = false
    // }, 1000);
 
 
  });


}








  DownLoadMaintenanceReport(){


    this.downloadExcelFile(this.VehicleApprovalChecklist)

   }


downloadExcelFile(vehicleInfoData) {
  const ws_name = 'VehicleInfo';
  const wb: WorkBook = { SheetNames: [], Sheets: {} };
  const ws: any = utils.json_to_sheet(vehicleInfoData);
  wb.SheetNames.push(ws_name);
  wb.Sheets[ws_name] = ws;
  const wbout = write(wb, { bookType: 'xlsx', bookSST: true, type: 'binary' });
  saveAs(new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' }), 'VehicleInfo.xlsx');
}
s2ab(s) {
  const buf = new ArrayBuffer(s.length);
  const view = new Uint8Array(buf);
  for (let i = 0; i !== s.length; ++i) {
    view[i] = s.charCodeAt(i) & 0xff;
  }
  return buf;
}







 
}







// WEBPACK FOOTER //
// ./src/app/maintenance/vehicleMaintenance/vehicleMnt/VehicleMaintenanceApproval.ts